// apiService.js
import constant from './constants';
const api = constant.api
export const originalImage = `${api}/`
export const signupUser = async (formData) => {
    try {
      const response = await fetch(`${api}/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        throw new Error('Failed to create account');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error during signup:', error);
      throw error;
    }
  };
  export const loginUser = async (formData) => {
    try {
      const response = await fetch(`${api}/users/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (!response.ok) {
        throw new Error('Failed to log in');
      }
      const data = await response.json();
        if (data.token) {
        localStorage.setItem('token', data.token);
      }
      return data;
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  };
  export const uploadImage = async (imageData) => {
    const formData = new FormData();
    formData.append('image', imageData);
    try {
      const token = localStorage.getItem('token'); 
      if (!token) {
        throw new Error('No token found');
      }
      const response = await fetch(`${api}/images/upload`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          // 'Accept': 'application/json',
        },
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Failed to upload image');
      }
  
      const data = await response.json();
      return data; 
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  };


export const uploadHistory = async (page = 1, limit = 10,  searchTerm = '') => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${api}/images/history?page=${page}&limit=${limit}&search=${searchTerm}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch image history');
    }

    const data = await response.json();
    return data;  
  } catch (error) {
    console.error('Error fetching image history:', error);
    return null;
  }
};


export const deleteApi = async (id) =>{
  try {
    const token = localStorage.getItem('token'); 
    if (!token) {
      throw new Error('No token found. Please log in.');
    }
    const response = await fetch(`${api}/images/delete`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id
      }),
    });
    if (!response.ok) {
      throw new Error('Deletion failed');
    }
    return response;
  } catch (error) {
    console.error('Error deleting record:', error);
    throw new Error('Failed to delete record. Please try again.');
  }
}

export const saveRemarkApi =  async(id, remark ) =>{
  try{
    const response = await fetch(`${api}/images/save-remark`, {
      method: 'POST',
      body: JSON.stringify({ id, remark }),
      headers: { 'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to save remark');
    }
    return response;

    } catch (error) {
      console.error(error);
    }
}

export const deleteRemarkApi =  async(id, remark ) =>{
  try{
    const response = await fetch(`${api}/images/delete-remark`, {
      method: 'POST',
      body: JSON.stringify({ id, remark }),
      headers: { 'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to save remark');
    }
    return response;

    } catch (error) {
      console.error(error);
    }
}